import { RootState } from '@/shared/store'

import { widgetWindowsAdapter } from './widgetWindowsAdapter'

export const widgetWindowsSelector = widgetWindowsAdapter.getSelectors<RootState>(
  (state) => state.widgetWindows,
)